import styled from 'styled-components';
import { BLACK, NEUTRAL_100, GRAYSCALE_400 } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

// TokenAmountDisplay Styles
export const TokenAmountCard = (styled.div`
  color: ${BLACK};
  border: 1px solid ${NEUTRAL_100};
  border-radius: 16px;
  padding: 16px;
  gap: 8px;
  display: flex;
  flex-direction: column;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TokenAmountLabel = (styled.span`
  color: ${BLACK};
  font-family: ${INTER.medium};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TokenAmountRow = (styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TokenAmountIcon = (styled.img`
  width: 28px;
  height: 28px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const TokenAmountValue = (styled.span`
  color: ${GRAYSCALE_400};
  font-family: ${INTER.bold};
  font-size: 20px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
